import { Link } from 'react-router-dom';
import { platforms } from '@/mocks/platforms';

export default function PlatformRecommendations() {
  const getColorClasses = (color: string) => {
    if (color === 'accent') return { badge: 'bg-accent-100 text-accent-700', btn: 'bg-accent-500 hover:bg-accent-600 text-white', star: 'text-accent-500' };
    if (color === 'secondary') return { badge: 'bg-secondary-100 text-secondary-700', btn: 'bg-secondary-500 hover:bg-secondary-600 text-white', star: 'text-secondary-500' };
    return { badge: 'bg-primary-100 text-primary-700', btn: 'bg-primary-500 hover:bg-primary-600 text-white', star: 'text-primary-500' };
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            推荐约炮平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选优质社交平台，助你快速找到合适的约会对象
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {platforms.map((platform) => {
            const colors = getColorClasses(platform.color);
            return (
              <div
                key={platform.name}
                className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colors.badge}`}>
                    <i className={`${platform.icon} text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-lg font-heading text-foreground-900">{platform.name}</h3>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${colors.badge}`}>
                        {platform.users} 用户
                      </span>
                    </div>
                    <div className="flex items-center gap-1 text-sm">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < Math.floor(platform.rating) ? `${colors.star} ri-star-fill` : i < platform.rating ? `${colors.star} ri-star-half-line` : 'text-foreground-300 ri-star-line'}`}
                        ></i>
                      ))}
                      <span className="text-foreground-600 ml-1">{platform.rating}</span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {platform.description}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                  <div>
                    <h4 className="text-xs font-medium text-foreground-500 mb-1.5">优势</h4>
                    <ul className="space-y-1">
                      {platform.pros.map((pro, i) => (
                        <li key={i} className="text-xs text-foreground-700 flex items-start gap-1.5">
                          <i className="ri-check-line text-green-500 shrink-0 mt-0.5"></i>
                          {pro}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-xs font-medium text-foreground-500 mb-1.5">不足</h4>
                    <ul className="space-y-1">
                      {platform.cons.map((con, i) => (
                        <li key={i} className="text-xs text-foreground-700 flex items-start gap-1.5">
                          <i className="ri-close-line text-red-400 shrink-0 mt-0.5"></i>
                          {con}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Link
                  to="/category/pingtai-tuijian"
                  className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-medium ${colors.btn} transition-colors whitespace-nowrap`}
                >
                  了解更多
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}